var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 14.6667C17.3333 16.0827 16.3867 17.3013 14.6653 17.3013C13.0453 17.3013 12 16.152 12 14.736C12 13.2827 13.0133 12 14.6667 12C16.32 12 17.3013 13.2133 17.3333 14.6667ZM12 36V18.6667H17.3333V36H12ZM20 24.592C20 22.532 19.932 20.8107 19.864 19.324H24.656L24.8933 21.6213H24.9947C25.6693 20.54 27.3227 18.9547 30.0907 18.9547C33.4667 18.9547 36 21.2147 36 26.0773V36H30.6667V26.852C30.6667 24.7267 29.8573 23.1053 28 23.1053C26.584 23.1053 25.8747 24.252 25.5027 25.1973C25.3667 25.536 25.3333 26.008 25.3333 26.4813V36H20V24.592Z",
    fill: "#000021"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.3cb433a3.svg";
export { ForwardRef as ReactComponent };